document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product__urgency-viewers').forEach(function (el) {
    var min = parseInt(el.dataset.min, 10) || 1;
    var max = parseInt(el.dataset.max, 10) || min;
    el.textContent = Math.floor(Math.random() * (max - min + 1)) + min;
  });

  var countdownEls = document.querySelectorAll('.product__urgency-countdown');
  if (!countdownEls.length) return;

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function nextCutoff(hour) {
    var now = new Date();
    var cutoff = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hour, 0, 0, 0);
    if (cutoff <= now) cutoff.setDate(cutoff.getDate() + 1);
    return cutoff;
  }

  function tick() {
    countdownEls.forEach(function (el) {
      var hour = parseInt(el.dataset.cutoffHour, 10);
      if (isNaN(hour)) return;
      var diff = nextCutoff(hour) - new Date();
      var hours = Math.floor(diff / 3600000);
      var minutes = Math.floor((diff % 3600000) / 60000);
      var seconds = Math.floor((diff % 60000) / 1000);
      el.textContent = pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
    });
  }

  tick();
  setInterval(tick, 1000);
});
